import script from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeader.vue?vue&type=style&index=0&id=29ac925d&lang=scss&scoped=true"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\bodensee\\wp-content\\themes\\io.shop-standalone-bodenseeenergie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ac925d"]])

export default __exports__